import React from "react";
import { tss } from "tss-react";
import limboSwitch from "assets/images/limbo_switch.svg";

const useStyles = tss.create({
    root: {
        width: 40,
        height: 24,
        padding: 7,
        cursor: "pointer",
    },
});

type IProps = {
    onClick?: (event: any) => void;
};

export default function Switcher(props: IProps) {
    const { classes } = useStyles();
    var { onClick } = props;
    return (
        <div className={classes.root} onClick={onClick}>
            <img src={limboSwitch} alt="limbo" />
        </div>
    );
}
